<template>
  <div class="app-list-toolbar">
    <div class="app-list-toolbar__left">
      <label class="app-list-toolbar__label">Show</label>
      <v-select
        :value="perPage"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="perPageOptions"
        :clearable="false"
        class="app-list-toolbar__per-page"
        @input="$emit('update:perPage', $event)"
      />
      <label class="app-list-toolbar__label">entries</label>
      <slot name="filters" />
    </div>

    <div class="app-list-toolbar__right">
      <slot name="search" />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'AppListToolbar',
  components: {
    vSelect,
  },
  props: {
    perPage: {
      type: Number,
      required: true,
    },
    perPageOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-list-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(34, 41, 47, .08);
}

.app-list-toolbar__left,
.app-list-toolbar__right {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: .75rem;
}

.app-list-toolbar__right {
  justify-content: flex-end;
  flex: 1;
}

.app-list-toolbar__label {
  margin-bottom: 0;
  color: #6e6b7b;
  white-space: nowrap;
}

.app-list-toolbar__per-page {
  width: 92px;
  flex: 0 0 92px;
}

@media (max-width: 991.98px) {
  .app-list-toolbar,
  .app-list-toolbar__left,
  .app-list-toolbar__right {
    align-items: stretch;
    flex-direction: column;
  }

  .app-list-toolbar__left,
  .app-list-toolbar__right {
    width: 100%;
  }

  .app-list-toolbar__per-page {
    width: 100%;
    flex-basis: auto;
  }
}
</style>
